<script>
  import {getContext, onMount} from 'svelte';
  import {Button} from '@px/button';
  import {envUtil} from '@/helper';
  import {genAppStoreUrl} from '@/helper/download';
  import {goto} from '@sapper/app';
  import {lang$, fixLink$} from '@/store';
  import {PATHS} from '@/const';
  import lang from '../Header.lang';

  const LG = getContext('LG');

  let show = true

  onMount(() => {
    const closeTime = localStorage.getItem("DOWNLOAD_CLOSE_TIME")
    show = Date.now() - closeTime > 24 * 60 * 60 * 1000

    if (envUtil.isMobile || envUtil.isApp) {
      updateLauncherPosition()
    }
  })

  function handleToDownload() {
    if (envUtil.isIOS) {
      goto(genAppStoreUrl($lang$));
    } else {
      goto($fixLink$(PATHS.DOWNLOAD.pathname));
    }
  }

  function handleColse() {
    show = false;
    localStorage.setItem("DOWNLOAD_CLOSE_TIME",  Date.now())
    const launcher = document.getElementById('launcher');
    if (launcher) {
      launcher.style.bottom = '16px'
    }
  }

  function updateLauncherPosition() {
    let count = 0
    let timer = setInterval(() => {
      count++
      const launcher = document.getElementById('launcher');
      if (launcher || count > 40) {
        clearInterval(timer)
        timer = null
      }
      if (launcher) {
        if (show) {
          launcher.style.bottom = '96px'
        } else {
          launcher.style.bottom = '16px'
        }
      }
    }, 500)
  }
</script>

<style>
  .wrap {
    position: fixed;
    bottom: 0;
    z-index: 1000;
    margin-bottom: 12px;
    box-sizing: border-box;
    padding: 0 16px;
    width: 100%;
  }
  .main {
    border-radius: 20px;
    padding: 12px;
    gap: 12px;
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.1);
  }
  .content {
    text-wrap: wrap;
    color: #1d2029;
  }
  .close {
    position: absolute;
    top: 4px;
    right: 12px;
    color: #999b9f;
    transform: scale(0.7);
  }
  :global(button.medium.btn-get) {
    border-radius: 40px;
    border-color: #999b9f !important;
    height: 38px;
    line-height: 38px;
    font-weight: 500;
    font-size: 14px;
    background: transparent;
    color: #1d2029;
  }
</style>

{#if show}
  <div class="wrap">
    <div class="df aic B1 pr main">
      <i class="iconfont close cp f12" on:click={handleColse}>&#xe65e;</i>
      <div class="f1 df aic">
        <img src="https://img.phemex.com/v1/7a8cc27e-8152-478e-ac6d-5a4780912b21/frame-1000005931.png" width="48px" height="48px" alt="phemex h5 logo" />
        <div class="content df fdc ml12">
          <span class="f16 fw3 lh24">{LG(lang.PhemexApp)}</span>
          <span class="f12 fw1 lh12">{LG(lang.TradeCrypto)}</span>
        </div>
      </div>
      <Button class="btn-get" type="default" on:click={handleToDownload}>{LG(lang.Get)}</Button>
    </div>
  </div>
{/if}
